import { render, staticRenderFns } from "./QuoteItemsSummary.vue?vue&type=template&id=bc360254&scoped=true"
import script from "./QuoteItemsSummary.vue?vue&type=script&lang=js"
export * from "./QuoteItemsSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteItemsSummary.vue?vue&type=style&index=0&id=bc360254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc360254",
  null
  
)

export default component.exports